import { Container } from './AssetStatus.styles';
import { CustomStatus } from './Components/CustomStatus/CustomStatus';

const AssetStatus = () => {
  return (
    <Container>
      <CustomStatus />
    </Container>
  );
};

export { AssetStatus };
